import React, { createContext, useContext } from "react";
import usePregnancyDataInternal, { UsePregnancyDataResult } from "../hooks/usePregnancyData";

const PregnancyContext = createContext<UsePregnancyDataResult | null>(null);

export const PregnancyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = usePregnancyDataInternal();
  return (
    <PregnancyContext.Provider value={value}>
      {children}
    </PregnancyContext.Provider>
  );
};

/**
 * Shared pregnancy state — all consumers see the same data.
 * When pregnancy is activated/deactivated, every component updates instantly.
 */
const usePregnancy = (): UsePregnancyDataResult => {
  const ctx = useContext(PregnancyContext);
  if (!ctx) throw new Error("usePregnancy must be used within PregnancyProvider");
  return ctx;
};

export default usePregnancy;
